export * from './contentieux-social.model';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contentieux-social/index.ts